import type { ReactNode } from 'react';
import { cn } from './cn';

type TagVariant = 'default' | 'amber' | 'teal' | 'neutral' | 'error';

// DESIGN §5 Tags: 4px radius, Geist Mono 12px uppercase +0.10em, padding 4px 9px.
const variants: Record<TagVariant, string> = {
  default: 'bg-accent-blue text-canvas-paper',
  amber: 'bg-signal-amber text-ink-navy', // text on solid amber is Ink Navy (AA)
  teal: 'bg-signal-teal text-canvas-paper',
  neutral: 'bg-canvas-deep-sand text-ink-mute',
  error: 'bg-signal-error-fill text-signal-error',
};

export function Tag({
  variant = 'default',
  children,
  className,
}: {
  variant?: TagVariant;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-[3px] rounded-xs px-[9px] py-[4px] font-mono text-label uppercase tracking-[0.1em]',
        variants[variant],
        className,
      )}
    >
      {children}
    </span>
  );
}
